<template>
    <div class="home-swiper">
        <div class="swiper-slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="slider in sliders.data" :key="slider.id">
                    <a :href="slider.link">
                        <!-- <div class="swiper-slide__img-holder"> -->
                        <v-img :src="slider.primary_image" aspect-ratio="2.5" cover></v-img>
                        <!-- </div> -->
                    </a>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";
    export default {
        name: "Carousel",
        data() {
            return {
                sliders: [],
                loading: false,
            }
        },
        props: {
            msg: String
        },
        methods: {
            getList() {
                this.loading = true
                axios.get(`/api/g/slider`)
                    .then(response => {

                        this.sliders = response.data.data
                        this.sliders.data.forEach((data, key) =>
                        {
                            if (data == null)
                            {
                                this.sliders.data[key].primary_image = data.gallery.url_original
                            }
                            else
                            {
                                this.sliders.data[key].primary_image = data.gallery.url_original
                            }
                        })

                    })
                    .catch(err => {

                    })
                    .finally(() => {
                        this.loading = false
                        this.loadSwiper()
                    });
            },
            loadSwiper() {
                let swiper = new Swiper(".swiper-slider", {
                    slidesPerView: 1,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    // loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                });
            }
        },
        mounted(){
            this.getList();
        }
    };

</script>

<style lang="scss">
    .home-swiper {
        position: relative;
        padding: 0;
        margin: 0;

        .swiper-wrapper {
            position: relative;
        }

        .swiper-slider {
            width: 100%;
            height: 100%;
            position: relative;
        }

        .swiper-slide {
            .swiper-slide__img-holder {
                width: 100%;

                // img {
                //     object-fit: contain;
                //     max-width: 100%;
                //     height: auto;
                // }
            }
        }

        .swiper-pagination {
            bottom: 5px;
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .swiper-pagination-bullet {
            width: 5px;
            height: 5px;
            border: 1px solid transparent;
            transition-duration: .3s;
            transition-property: border;
            transition-timing-function: ease-in-out;
        }

        .swiper-pagination-bullet-active {
            background: transparent;
            border: 1px solid #fff;
            width: 8px;
            height: 8px;
        }
    }

</style>
